/**
 * Mensaje localizado para un error de la API de asistencia/caseta. El backend responde con un código
 * (`{ error: 'NO_FACE' }`); si no hay texto para ese código se usa `fallback`, nunca el código crudo.
 */
export function attendanceErrorMessage(err: unknown, errors: Record<string, string>, fallback: string): string {
  const code = (err as { response?: { data?: { error?: unknown } } } | null)?.response?.data?.error;
  if (typeof code === 'string' && errors[code]) return errors[code];
  return fallback;
}
